import React, { useState } from 'react';
import './AddPathhForm.css';

const AddPathhForm = ({ categoryId, categoryName, onClose, onPathhAdded }) => {
  const [formData, setFormData] = useState({
    title: '',
    pathh_text: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim() || !formData.pathh_text.trim()) {
      setError('Both title and pathh text are required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(`https://pooja-path-1.onrender.com/api/pathh/categories/${categoryId}/pathhs/add/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: formData.title.trim(),
          pathh_text: formData.pathh_text.trim()
        }),
      });

      if (response.ok) {
        const data = await response.json();
        alert('Pathh added successfully!');
        onPathhAdded();
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Failed to add pathh');
      }
    } catch (error) {
      console.error('Error adding pathh:', error);
      setError('Failed to add pathh. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (error) setError(''); // Clear error when user starts typing
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content pathh-form-modal">
        <div className="modal-header">
          <h3>📖 Add Pathh to "{categoryName}"</h3>
          <button className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="add-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="title" className="form-label">
              Pathh Title *
            </label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter pathh title"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="pathh_text" className="form-label">
              Pathh Text *
            </label>
            <textarea
              id="pathh_text"
              name="pathh_text"
              value={formData.pathh_text}
              onChange={handleInputChange}
              className="form-textarea"
              placeholder="Enter the complete pathh text..."
              rows="12"
              required
            />
            <div className="character-count">
              {formData.pathh_text.length} characters
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              onClick={onClose}
              className="cancel-button"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={loading}
            >
              {loading ? '❳ Adding...' : '✅ Add Pathh'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddPathhForm;
